/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLegalContact, FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLegalContact';
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLegalContact(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLegalContact(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValue.js.map